'use strict';

const sortArray = (array, direction, key=null) => {
  const func = direction === 'desc' ? sortDesc : sortAsc;
  return [...array].sort( (a, b) => {
    const valA = key ? a[key] : a;
    const valB = key ? b[key] : b;
    return func(valA, valB);
  } );
};

function sortDesc(a, b){
  if (a < b) return 1;
  if (b < a) return -1;

  return 0;
}

function sortAsc(a, b){
  if (a > b) return 1;
  if (b > a) return -1;

  return 0;
}
export default sortArray;
